const formatForTrailCard = initialTrail => {
  return {
    ID: initialTrail.id,
    area_id: initialTrail.area.id,
    name: initialTrail.name,
    name_de: initialTrail.name,
    name_en: initialTrail.name,
    name_es: initialTrail.name,
    name_fr: initialTrail.name,
    area_name: initialTrail.name,
    area_name_de: initialTrail.name,
    area_name_en: initialTrail.name,
    area_name_es: initialTrail.name,
    area_name_fr: initialTrail.name,
    area_slug: initialTrail.area.slug,
    avg_rating: initialTrail.defaultActivityStats.rating,
    city_id: initialTrail.location.city_id,
    city_name: initialTrail.location.city,
    city_name_de: initialTrail.location.city,
    city_name_en: initialTrail.location.city,
    city_name_es: initialTrail.location.city,
    city_name_fr: initialTrail.location.city,
    country_id: initialTrail.location.country,
    country_name: initialTrail.location.country,
    country_name_de: initialTrail.location.country,
    country_name_en: initialTrail.location.country,
    country_name_es: initialTrail.location.country,
    country_name_fr: initialTrail.location.country,
    difficulty_rating: initialTrail.defaultActivityStats.difficulty,
    duration_minutes: initialTrail.defaultActivityStats.duration,
    length: initialTrail.trailGeoStats.length,
    num_photos: initialTrail.photoCount,
    num_reviews: initialTrail.trailCounts.reviewCount,
    objectID: `trail-${initialTrail.id}`,
    overview: null,
    slug: initialTrail.slug,
    state_id: initialTrail.location.region,
    state_name: initialTrail.location.regionName,
    state_name_de: initialTrail.location.regionName,
    state_name_en: initialTrail.location.regionName,
    state_name_es: initialTrail.location.regionName,
    state_name_fr: initialTrail.location.regionName,
    type: 'trail'
  };
};

const formatForActivity = initialActivity => {
  return {
    ID: initialActivity.id,
    activity: initialActivity.activity,
    created_at: initialActivity.createdAt,
    duration_minutes: initialActivity.summaryStats.duration,
    length: initialActivity.summaryStats.distanceTotal,
    name: initialActivity.name,
    name_de: initialActivity.name,
    name_en: initialActivity.name,
    name_es: initialActivity.name,
    name_fr: initialActivity.name,
    objectID: `track-${initialActivity.id}`,
    photo_count: initialActivity.photoCount,
    rating: initialActivity.rating,
    slug: initialActivity.slug,
    type: 'track',
    user: {
      first_name: initialActivity.user.firstName,
      last_name: initialActivity.user.lastName,
      id: initialActivity.user.id,
      profile_photo_url: initialActivity.user.profilePhoto.href,
      slug: initialActivity.user.slug
    }
  };
};

const formatListAdditions = additions => {
  let additionData;
  return additions.map(addition => {
    if (addition.additionType === 'trail') {
      additionData = formatForTrailCard(addition.additionData);
    }

    if (addition.additionType === 'activity') {
      additionData = formatForActivity(addition.additionData);
    }

    return { ...addition, additionData };
  });
};

const parseActivityAndTrail = sections => {
  return sections.map(section => {
    if (section.section_type !== 'feed-item') {
      return section;
    }

    if (section.itemData.additions) {
      section.itemData.additions = formatListAdditions(section.itemData.additions);
    }

    if (section.itemData.trail) {
      section.itemData.trail = formatForTrailCard(section.itemData.trail);
    }

    if (section.itemData.activity) {
      section.itemData.activity = formatForActivity(section.itemData.activity);
    }

    return section;
  });
};

export default parseActivityAndTrail;
